import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Coverage = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="coverage icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.32821 3.89113C1.74484 15.5015 5.80234 19.8807 12.0958 22.7347C20.7121 18.8086 22.3125 12.3548 21.8653 3.89113C17.519 4.79902 13.3475 2.22022 12.0967 1.34903C10.846 2.22022 6.67643 4.79998 2.32821 3.89113M12.0967 24C12.0127 24 11.9297 23.9836 11.8514 23.9488C2.136 19.6412 0.552988 12.4929 1.16533 3.08659C1.17789 2.90308 1.27254 2.73406 1.42418 2.62975C1.57582 2.52447 1.76609 2.49453 1.94284 2.54765C6.69382 3.97903 11.6756 0.164919 11.7259 0.127251C11.9441 -0.0417717 12.2493 -0.0427375 12.4667 0.126285C12.5169 0.164919 17.5084 3.9829 22.2497 2.54765C22.4264 2.49357 22.6157 2.52447 22.7693 2.62975C22.92 2.73406 23.0146 2.90308 23.0272 3.08659C23.6405 12.492 22.0575 19.6402 12.3411 23.9488C12.2638 23.9836 12.1798 24 12.0967 24M18.2071 7.29289C18.5976 7.68342 18.5976 8.31658 18.2071 8.70711L10.5 16.4142L6.79289 12.7071C6.40237 12.3166 6.40237 11.6834 6.79289 11.2929C7.18342 10.9024 7.81658 10.9024 8.20711 11.2929L10.5 13.5858L16.7929 7.29289C17.1834 6.90237 17.8166 6.90237 18.2071 7.29289Z"
    />
  </svg>
)
